import { useEffect, useState } from 'react';
import {
  Box, Button, Input, FormControl, FormLabel,
  Heading, useToast, VStack, Select
} from '@chakra-ui/react';

import CommonService from '../services/CommonService';

const Payment = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  const [amount, setAmount] = useState(0);
  const [sId, setSID] = useState(0);
  const [pId, setPID] = useState(0);
  const [data, setData] = useState([]);
  const [mode, setMode] = useState([]);
  const toast = useToast();

  useEffect(() => {
    getSubscription();
    paymentModes();
  }, [])

  const getSubscription = async () => {
    let param = {
      authToken: user.authToken,
    };
    setData([])
    try {
      const res = await CommonService.getLiveSubs(param)
      if (res.statusCode === 200) {
        setData(res.data)
      }
    } catch (error) {
      const er = error.response?.data?.message || "Something went wrong.";
      toast({ title: er, status: "error" });
    }
  }

  const paymentModes = async () => {
    let param = {
      authToken: user.authToken,
    };
    setMode([])
    try {
      const res = await CommonService.getActivePaymentMode(param)
      if (res.statusCode === 200) {
        setMode(res.data)
      }
    } catch (error) {
      const er = error.response?.data?.message || "Something went wrong.";
      toast({ title: er, status: "error" });
    }
  }

  const handleSId = async (e) => {
    const subId = Number(e.target.value)
    setSID(subId)

    const selectedPlan = data.find((plan) => plan.sId === subId);
    if (selectedPlan) {
      setAmount(selectedPlan.Rate);
    } else {
      setAmount(0); // fallback in case no match
    }
  }

  const handlePayment = async () => {

    if (sId === 0 || pId === 0 || amount === 0) {
      toast({ title: "Please Fillup Required fields ", status: "error" });
      return false;
    }

    let params = {
      amount: amount,
      authToken: user.authToken,
      currency: 'INR',
      uId: user.uId,
      sId: sId,
      pId: pId
    };

    try {
      // Step 1: Create order from backend
      const order = await CommonService.createOrder(params);

      // Step 2: Open Razorpay checkout
      const options = {
        key: "rzp_test_Z50p6ZM95VvlSy", // Replace with your actual key
        amount: order.amount,
        currency: order.currency,
        name: "Eat-Out",
        description: "Test Transaction",
        order_id: order.orderId,
        handler: async function (response) {  // make this async
          const verifyParams = {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
            billId: order.billId,
            authToken: user.authToken,
            uId: user.uId,
          };

          const verification = await CommonService.verifyPayment(verifyParams);
          if (verification.statusCode === 200) {
            setPID(0)
            setSID(0)
            setAmount(0)
            //session
            user.subscription = 1;
            localStorage.setItem("user", JSON.stringify(user));
            toast({
              title: "Payment Successful",
              status: "success",
              duration: 3000,
              isClosable: true,
              position: "top"
            });
          } else {
            toast({ title: "Payment Verification Failed", status: "error" });
          }
        },
        prefill: {
          name: user.FName || "",
          email: user.Email || "",
          contact: user.MobileNo || "",
        },
        theme: {
          color: "#319795"
        }
      };

      const rzp = new window.Razorpay(options);
      rzp.open();

    } catch (error) {
      console.error("Payment error:", error);
      toast({ title: "Payment failed", status: "error" });
    }
  };

  return (
    <Box maxW="1000px" mx="auto" px={4}>
      <Box maxW="900px" mx="auto" mt={2}>
        <Box bg="blue.500" color="white" py={3} px={6} borderTopRadius="lg">
          <Heading size="sm" textAlign="center">
            Choose a Plan
          </Heading>
        </Box>
        <Box p={6} bg="white">
          <VStack spacing={4}>
            <FormControl isRequired>
              <FormLabel fontSize="sm">Plan</FormLabel>
              <Select value={sId} onChange={handleSId} placeholder="Select plan" size="sm">
                {data.map((row) => (
                  <option value={row.sId} key={row.sId}>
                    {row.Name} – ₹{row.Rate}
                  </option>
                ))}
              </Select>
            </FormControl>

            <FormControl isRequired>
              <FormLabel fontSize="sm">Amount (₹)</FormLabel>
              <Input
                type="number"
                value={amount}
                placeholder="Enter amount"
                isReadOnly
                size="sm"
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel fontSize="sm">Payment Mode</FormLabel>
              <Select value={pId} onChange={(e) => setPID(Number(e.target.value))} placeholder="Select" size="sm">
                {mode.map((row) => (
                  <option value={row.pId} key={row.pId}>
                    {row.Name}
                  </option>
                ))}
              </Select>
            </FormControl>

            <Box textAlign="center" pt={4}>
              <Button
                size="sm"
                bg="#62a13b"
                color="white"
                onClick={handlePayment}
                isDisabled={sId === 0 || pId === 0 || !amount}
                _hover={{ bg: "#538d32" }}
                boxShadow="lg"
                px={10}
                py={2}
                borderRadius="full"
              >
                Pay Now
              </Button>
            </Box>
          </VStack>
        </Box>
      </Box>
    </Box>
  )
}

export default Payment
